// extracted by mini-css-extract-plugin
export default {"buttonSpacing":"confirmation-module__buttonSpacing--qG4A8"};